import { BaseElementToSimpleSapElementMapper } from '../baseElementToSimpleSapElementMapper';
import Element from '@/models/element';
import { ISimpleSapElement, SimpleSapElement } from '@/models/api/models/simpleSapElement';

export class HangerToSimpleSapElementMapper extends BaseElementToSimpleSapElementMapper {

    public map(element: Element): ISimpleSapElement[] {
        const color = '';
        const type = this.formatType('DRU', 0, element.shape.x);
        const hanger = SimpleSapElement.ELEMENT(type, color);
        return [hanger];
    }
}